import { apiClient } from './client';
import type { DashboardStats, ChartDataPoint } from '../types';

export const dashboardApi = {
  getStats: async (): Promise<DashboardStats> => {
    const response = await apiClient.get<DashboardStats>(
      '/admin/dashboard'
    );
    return response.data;
  },

  getChartData: async (days: number = 7): Promise<ChartDataPoint[]> => {
    const response = await apiClient.get<ChartDataPoint[]>(
      '/admin/dashboard/chart',
      { params: { days } }
    );
    return response.data;
  }
};
